// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SXhQE{width:320px;max-height:360px;display:flex;flex-direction:column;overflow:hidden}.iPcqW{padding:12px 12px 8px;border-bottom:1px solid #d4d4e0}.jCd_y{display:flex;align-items:center;border:1px solid #d4d4e0;border-radius:4px;gap:4px;padding-right:8px}.jCd_y:focus-within{border-color:#6942f8}.n2HUb{flex:1;padding:8px 12px;border:none;border-radius:4px;font-size:14px;outline:none;box-sizing:border-box;min-width:0;background:transparent}.n2HUb::placeholder{color:#a9a9c1}.H9u6Q{display:flex;align-items:center;gap:4px;background:none;border:none;color:#6942f8;font-size:14px;font-weight:500;cursor:pointer;padding:0;white-space:nowrap;flex-shrink:0}.H9u6Q:hover{color:#4520cc}.wgUab{display:inline-flex;align-items:center;justify-content:center;width:20px;height:21px;border-radius:4px;border:1px solid #6942f8;background-color:#e1d9fe;font-size:12px;font-family:inherit;line-height:1;color:#6942f8}.aC_m3{overflow-y:auto;flex:1}.mENDC{padding:8px 12px 4px;font-size:11px;font-weight:600;color:#a9a9c1;text-transform:uppercase;letter-spacing:.5px}.l8D2Y{padding:8px 12px;cursor:pointer;font-size:14px;color:#535382;display:flex;align-items:center;transition:background-color .1s}.l8D2Y:hover,.l8D2Y.Aj0vd{background-color:#eaeaef}.pNZGx{display:flex;align-items:center;padding:12px;border-top:1px solid #d4d4e0;cursor:pointer;gap:12px;background-color:#f4f4f7;transition:background-color .1s}.pNZGx:hover{background-color:#eaeaef}.C43KI{display:flex;flex-direction:column;flex:1;min-width:0}.vgd3D{font-size:14px;font-weight:600;color:#6942f8}.kGxMc{font-size:12px;color:#9393b1;line-height:1.4}.sOlr3{display:flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:50%;background-color:#6942f8;color:#fff;flex-shrink:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"popoverContent": `SXhQE`,
	"searchContainer": `iPcqW`,
	"inputWrapper": `jCd_y`,
	"searchInput": `n2HUb`,
	"createAction": `H9u6Q`,
	"kbdHint": `wgUab`,
	"listContainer": `aC_m3`,
	"categoryHeader": `mENDC`,
	"variableItem": `l8D2Y`,
	"highlighted": `Aj0vd`,
	"manageTagsCta": `pNZGx`,
	"manageTagsContent": `C43KI`,
	"manageTagsTitle": `vgd3D`,
	"manageTagsDescription": `kGxMc`,
	"manageTagsArrow": `sOlr3`
};
export default ___CSS_LOADER_EXPORT___;
